export default __webpack_public_path__ + "static/media/homepage_logo.71cced73.svg";